import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';

const Navbar = () => {
  const [navbarBg, setNavbarBg] = useState('');
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setNavbarBg('bg-white shadow-lg backdrop-blur-md');
      } else {
        setNavbarBg('');
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = ['home', 'services', 'packages', 'destination', 'footer'];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${navbarBg}`}
    >
      <div className="container mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center space-x-3 group">
          <img
            src="/logo.png"
            alt="Logo"
            className="h-10 w-10 bg-red-500 rounded-full object-contain transform group-hover:scale-110 transition-transform duration-300"
          />
          <a
            className="text-black font-bold text-2xl group-hover:text-red-500 transition-colors duration-300"
            href="#home"
          >
            Shiv Shakti Travels
          </a>
        </div>

        {/* Hamburger Icon */}
        <button
          className="block md:hidden text-black focus:outline-none"
          onClick={toggleMenu}
        >
          <svg
            className="w-7 h-7"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16m-7 6h7"
            />
          </svg>
        </button>

        {/* Mobile Menu */}
        <div
          className={`absolute top-16 left-0 w-full bg-white shadow-md md:hidden transition-all duration-300 ease-in-out transform ${
            isMenuOpen
              ? 'opacity-100 translate-y-0'
              : 'opacity-0 -translate-y-5 pointer-events-none'
          }`}
        >
          <ul className="flex flex-col space-y-4 px-6 py-4">
            {navItems.map((section, idx) => (
              <li key={idx}>
                <Link
                  to={section}
                  smooth={true}
                  duration={500}
                  onClick={() => setIsMenuOpen(false)}
                  className="text-black relative font-semibold cursor-pointer transition-colors duration-300 hover:text-red-500 before:absolute before:bottom-0 before:left-0 before:h-[2px] before:w-0 before:bg-red-500 before:transition-all before:duration-300 hover:before:w-full"
                >
                  {section === 'footer'
                    ? 'Contact Us'
                    : section.charAt(0).toUpperCase() + section.slice(1)}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex space-x-8">
          {navItems.map((section, idx) => (
            <Link
              key={idx}
              to={section}
              smooth={true}
              duration={500}
              className="text-black relative font-semibold cursor-pointer transition-colors duration-300 hover:text-red-500 before:absolute before:bottom-0 before:left-0 before:h-[2px] before:w-0 before:bg-red-500 before:transition-all before:duration-300 hover:before:w-full"
            >
              {section === 'footer'
                ? 'Contact Us'
                : section.charAt(0).toUpperCase() + section.slice(1)}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
